// create nested structure for dropdown like here: https://dowjones.github.io/react-dropdown-tree-select/#/story/readme
import { format } from "d3-format";

import { group } from "d3-array";
// import pumaNames from "../data/puma-names-2010";
const colors = require("../data/final_cuts_cols_for_app.json");

var fmt = format(",");

export function dropdownTree(data) {
  if (data.constructor === Array) {
    // means single level
    return data.map((d) => ({
      label: d,
      value: d,
    }));
  } else if (data.constructor === Object) {
    // recursively call this function on each sub category
    return Object.keys(data).map((prop) => ({
      label: prop,
      children: dropdownTree(data[prop]),
    }));
  }
}

function makeMapData(filteredData, colorStops) {
  return [filteredData, colorStops];
}

export function clean(s) {
  return s.replace(/ /gi, "-").toLowerCase();
}

function makeTableData(filteredData, selectedOptions) {
  var selectedGeography = selectedOptions["Geography"][0];
  // for eg population can have age groups
  var subcats = selectedOptions["Variable"][1];

  var tableHeaders = [
    {
      title: "Area",
      field: "puma_name",
    },
    ...Array.from(subcats).map((d) => ({
      title: d,
      field: clean(d) + "_count",
    })),
    ...Array.from(subcats).map((d) => ({
      title: d,
      field: clean(d) + "_pct",
    })),
  ];

  // add rows
  var tableData = Array.from(
    group(filteredData, (d) => d.puma),
    ([key, values]) => ({ key, values })
  );

  console.log(tableData);

  tableData = tableData.map((d) => {
    return d.values.reduce((obj, val) => {
      obj["puma_name"] =
        val.puma === "Total"
          ? "New York City"
          : val.cd_name === "NA"
          ? selectedGeography + " total"
          : val.cd_name;
      obj["puma"] = +val.puma;
      console.log(val);
      obj.cd_num =
        val.puma === "Total"
          ? 1000
          : val.cd_name === "NA"
          ? 100
          : +val.cd_name.split(" ")[2];

      obj[clean(val.variable2) + "_pct"] =
        val.percent_final === "" ? "NA" : (+val.percent_final).toFixed(1) + "%";
      obj[clean(val.variable2) + "_count"] =
        val.count === "" || val.count === "NA" ? "NA" : fmt(+val.count);
      return obj;
    }, {});
  });

  tableData.sort((a, b) => {
    return a.cd_num - b.cd_num;
  });

  // put borough and nyc total on the top
  var nycBoroTotals = tableData.splice(-2).reverse();

  tableData.unshift(...nycBoroTotals);

  return [tableHeaders, tableData];
}

export function makeData(data, selectedOptions) {
  var filteredDataTable = data.filter(
    (d) =>
      (d.borough === selectedOptions["Geography"][0] ||
        d.borough === "Total") &&
      d.fb_type === selectedOptions["Immigrant status"][0] &&
      d.category_final === selectedOptions["Demographics"][0]
  );

  var filteredDataMap = data.filter(
    (d) =>
      d.fb_type === selectedOptions["Immigrant status"][0] &&
      d.category_final === selectedOptions["Demographics"][0] &&
      d.variable2 === selectedOptions["Variable"][0]
  );

  var colorStops =
    colors[
      selectedOptions["Demographics"][0] + ": " + selectedOptions["Variable"][0]
    ];

  return [
    makeMapData(filteredDataMap, colorStops),
    makeTableData(filteredDataTable, selectedOptions),
  ];
}
